// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_KS2","name":"styles_name__2bGir","phone":"styles_phone___R7hY"};